import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Row, Col, Label, Alert, Button } from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import "react-dropzone-uploader/dist/styles.css";
import {
  checkWhiteSpaces,
  alphaNumericHavells,
  checkPaymentTermsRemarks,
  numberHavells,
  email,
  userDetails,
  alphaNumeric,
  validateUrlHavells,
  notify,
} from "../../../helper";
import HeaderTitle from "../../common/HeaderTitle";
import Toaster from "../../common/Toaster";
import TooltipCustom from "../../common/Tooltip";
import {
  SearchableSelectHookForm,
  TextAreaHookForm,
  TextFieldHookForm,
} from "../../layout/HookFormInputs";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  getCountryService,
  getDistrictSelection,
  getServiceHowDidYouHearAbout,
  getStateSelection,
  getTypeEstablishment,
  getVendorRegistrationId,
  getYearOfBuisnessService,
  saveNewSupplier,
} from "./Actions";
import FileUpload from "../FileUpload";
import { getSelectSupplierService, getSelectSupplierPlant } from "./Actions";
import { getUser } from "./Actions";
import { getSelectSupplierCategoryService } from "./Actions";
import { getDivisionByCategoryService } from "./Actions";
import { getAllSupplierSpecializationService } from "./Actions";
import { getPaymentTermsService } from "./Actions";
import { getSourceOfOrigin } from "./Actions";
import { getCommercialReasonService } from "./Actions";
import LoaderCustom from "../../common/LoaderCustom";
import { API } from "../../../config/constants";
import axiosHelper from "../../../axiosHelper";
function AddVendorNeed(props) {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    setError,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      NewBusinessVertical: "true",
      Importlocalization: "true",
      DuetoSingleSource: "true",
      DiscussionWithNDTTeam: "true",
      NewLocationAddedByExistingSupplier: "true",
      Commercial: "true",
      Other: "true",
      CostSheet: "true",
      ReplacementExistingVendor: "true",
      CostSaving: "true",
      ExistingSupplierAvialableAndDiscussion: "true",
      supplierOrigin: "1",
      HasSisterConcernWithQRG: "true",
      HasISO9001OrIATF16949: "true",
      HasRelationWithQRGEmployees: "true",
      IsRegisteredUnderMSMEDAct: "true",
      HasFactoryLicense: "true",
      VendorRelation: "true",
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const urlParams = new URLSearchParams(window.location.search);

  const supplierId = urlParams.get("id");
  const modeEdit = urlParams.get("mode");
  const VendorRegID = urlParams.get("VendorRequirementRegistrationId");

  const [hasSupplierCodeChanged, setHasSupplierCodeChanged] = useState(false);
  const [isSupplierCodeValid, setIsSupplierCodeValid] = useState(false);

  const [supplierOrigin, setSupplierOrigin] = useState("1");
  const [selectedEstablishmentType, setSelectedEstablishmentType] =
    useState("");
  const [supplierSpecialization, setSupplierSpecialization] = useState([]);
  const [yearOfBuisness, setYearOfBuisness] = useState([]);
  const [costSaving, setCostSaving] = useState("true");

  const [masterCurrencyList, setCurrencyMasterList] = useState([]);
  const [currencyScaleData, setCurrencyScaleData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateOptionData, setOptionData] = useState([]);
  const [cityOptionData, setCityOptionData] = useState([]);
  const [howDidYouHearAboutData, setHowDidYouHearAbout] = useState(null);
  const [districtOptionData, setDistrictOptionData] = useState([]);
  const [setDisable, setSetDisable] = useState(false);
  const [establishment1, setEstablishment] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showSupplierOriginPopup, setShowSupplierOriginPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSelfAssesmentRequired, setIsSelfAssesmentRequired] = useState(false);

  const [paymentTermsMaster, setPaymentTermsMaster] = useState([]);
  const [downloadButtonForSupplier, setDownloadButtonForSupplier] = useState(null)


  const [dataVendorRegistrationIdData, setDataVendorRegistrationByIdData] =
    useState(null);
  const [remarks, setRemarks] = useState("");
  // Event handler to update the state when the value changes
  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };
  const [uploadEvidenceFile, setUploadEvidenceFile] = useState({
    fileName: dataVendorRegistrationIdData?.CompanyProfileDocumentName,
    base64String: "",
    fileType: "",
  });
  const [isoFile, setIsoFile] = useState({
    fileName: dataVendorRegistrationIdData?.CompanyProfileDocumentName,
    base64String: "",
    fileType: "",
  });

  const [companyProfile, setCompanyProfile] = useState({
    fileName: dataVendorRegistrationIdData?.CompanyProfileDocumentName,
    base64String: "",
    fileType: "",
  });
  const [saveRiskFile, setSaveRiskFile] = useState({
    fileName: dataVendorRegistrationIdData?.SaveriskDocumentName,
    base64String: "",
    fileType: "",
  });
  const [selectedPotentialSupplierList, setSelectedpotentialSupplierList] =
    useState([]);
  const [sendToApiPotentialData, setSendToApiPotentialData] = useState(null);
  const [
    selectedPotentialSupplierListPlant,
    setSelectedpotentialSupplierListPlant,
  ] = useState([]);
  const [popupLoader, setPopupLoader] = useState(false);
  const [idDataFromSupplier, setIdByDataInSupplierNeedForm] = useState(false);

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryCostSheet, setSelectedCategoryCostSheet] = useState('');



  const [checkDivison, setCheckDivison] = useState(false);
  const [sourceOfOriginList, setSourceOfOriginList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null); // Step 1: Manage state for selected year
  const [commercialReasonMaster, setCommercialReasonMaster] = useState(null);
  const [isDateValid, setIsDateValid] = useState(true);

  const [dataForSelfAssesmentRequired, setDataForSelfAssesmentRequired] =
    useState(null);
  const currentYear = new Date().getFullYear();
  const yearsDifference = currentYear - selectedYear < 3;
  const history = useHistory();
  const [IsExceptionalSupplier1, setIsExceptionalSupplier] = useState(false);

  const [vendorRelation, setVendorRelation] = useState("0");
  console.log('vendorRelation: ', vendorRelation);

  const defaultCountry = countryList.find(
    (country) => country?.Name === "India"
  );
  useEffect(() => {
    if (defaultCountry && supplierOrigin === "1") {
      void handleCountryChange(defaultCountry?.Id, false);
      setValue("Country", {
        value: defaultCountry.Id || "",
        label: defaultCountry.Name || "", // Provide the label property
      });
      // Disable the field when supplierOrigin is '1'
      setIsDateValid(true);
    } else {
      // setValue("Country", null); // Clear the field
      // Enable the field if supplierOrigin is not '1'
      setIsDateValid(false);
    }
  }, [defaultCountry, supplierOrigin]);
  useEffect(() => {
    const fetchData = async () => {
      // setShowPopup(true);
      // Fetch data for the first use case
      getYearOfBuisnessCorporation();
      getSelectSupplierNeedForm();
      getAllSupplierSpecialization();
      getOriginOfSourceRef();
      getSelectSupplierNeedFormPlant();
      getPaymentTermsOfVendorNeedForm();
      getCommercialReasonOfVendorNeedForm();
      //    getSupplierSpecializationList();
      getSelectSupplierCategory();
      getCountryMasterList();
      getTypeOfEstablishment();
    };
    // if(isSelfAssesmentRequired){
    //   setShowPopup(true)

    // }

    // Fetch all the data when the component mounts and when 'selectedBusinessTypeId' or 'countySelectId' changes
    void fetchData();
    if (supplierId) {
      setLoading(true);
      getUser(supplierId)
        .then(async (res) => {
          const userData = res?.Data;
          const data = { ...userData[0] };
          setDownloadButtonForSupplier(data)
          getSelectSupplierCategory(data);
          setIsExceptionalSupplier(data?.IsExceptionalSupplier);
          void handleCountryChange(data?.Country, false);
          void handleStateChange(data?.State, false);
          // void handleDistrictChange(data?.District, false);
          setCompanyProfile({
            fileName: data?.CompanyProfileAttachmentName,
            base64String: "",
            fileType: "",
          });
          setSaveRiskFile({
            fileName: data?.RiskAssessmentDocumentAttachmentName,
            base64String: "",
            fileType: "",
          });
          setValue("YearOfBusinessIncorporation", {
            value: data?.YearOfBusinessIncorporationId || "",
            label: data?.YearOfBusinessIncorporationName,
          });
          setSelectedYear(data?.YearOfBusinessIncorporationName);
          setValue("EstablishmentRemarks", data?.EstablishmentRemarks);
          setValue("CompanyProfileWebsite", data?.CompanyProfileWebsite);
          // setValue("CompanyProfileWebsite",data?.CompanyProfileWebsite)

          setValue("Country", {
            value: data?.CountryId || "",
            label: data?.CountryName || "", // Provide the label property
          });
          setValue("State", {
            value: data?.StateId || "",
            label: data?.StateName || "", // Provide the label property
          });
          setValue("City", data?.CityName);
          setValue("District", data?.DistrictName);
          setValue("Email", data?.Email);
          setValue("MobileNo", data?.ContactNumber);
          setValue("SupplierOrigin", data?.SupplierOrigin);
          setValue("CompanyName", {
            value: data?.SupplierRepositoryRequestId || "",
            label: data?.SupplierVendorName || "", // Provide the label property
          });
          setValue("SupplierSpecialization", {
            value: data?.SupplierSpecialization || "",
            label: data?.SpecializationName || "", // Provide the label property
          });
          setValue("OtherSupplierSpecialization", (data?.OtherSpecialization && data?.OtherSpecializationName) ? {
            value: data?.OtherSpecialization,
            label: data?.OtherSpecializationName, // Provide the label property
          } : null);
          setValue("ContactPersonName", data?.ContactPersonName);
          setValue("ContactPersonDesignation", data?.ContactPersonDesignation);
          setValue("SupplierOriginSources", {
            value: data?.HowDidYouHearAboutUsId || "",
            label: data?.HowDidYouHearAboutUsName || "", // Provide the label property
          });

          setValue("VendorName", data?.SupplierVendorName);

          setSupplierOrigin(`${data?.SupplierOrigin}`);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
    if (VendorRegID) {
      setLoading(true);
      getVendorRegistrationId(VendorRegID)
        .then(async (res) => {
          const userDataVendor = res?.Data;
          const dataVendor = { ...userDataVendor[0] };
          setDataVendorRegistrationByIdData(dataVendor);
          setCostSaving(dataVendor?.CostSaving.toString());
          setRemarks(dataVendor?.Remarks);
          void handleCountryChange(dataVendor?.Country, false);
          void handleStateChange(dataVendor?.State, false);
          setSaveRiskFile({
            fileName: dataVendor?.SaveriskDocumentName,
            base64String: "",
            fileType: "",
          });
          setCompanyProfile({
            fileName: dataVendor?.CompanyProfileDocumentName,
            base64String: "",
            fileType: "",
          });
          setIsoFile({
            fileName: dataVendor?.CostSheetDocumentName,
            base64String: "",
            fileType: "",
          });
          setValue("CostSheetDocument", dataVendor?.CostSheetDocumentName);
          setUploadEvidenceFile({
            fileName: dataVendor?.CostSavingDocumentName,
            base64String: "",
            fileType: "",
          });
          // void handleDistrictChange(dataVendor?.District, false);
          void handleYearChange(dataVendor?.Establishment_Year, false);
          void handleCategoryDivisionMaster(dataVendor?.Category, false);
          setVendorRelation(dataVendor?.VendorRelation?.toString() || "0");
          setValue("VendorRelation", dataVendor?.VendorRelation?.toString() || "0");

          setSupplierOrigin(`${dataVendor?.SupplierOrigin}`);
          setValue("YearOfBusinessIncorporation", {
            value: dataVendor?.YearOfBusinessIncorporation || "",
            label: dataVendor?.Establishment_Year,
          });
          setSelectedYear(dataVendor?.Establishment_Year);
          setValue("Country", {
            value: dataVendor?.Country || "",
            label: dataVendor?.CountryName || "", // Provide the label property
          });
          setValue("State", {
            value: dataVendor?.State || "",
            label: dataVendor?.StateName || "", // Provide the label property
          });
          setValue("City", dataVendor?.City);
          setValue("District", dataVendor?.District);
          setValue("Plant", {
            value: dataVendor?.Plant || "",
            label: dataVendor?.PlantName || "", // Provide the label property
          });
          setValue("Category", {
            value: dataVendor?.Category || "",
            label: dataVendor?.CategoryName || "", // Provide the label property
          });

          setValue("Division", {
            value: dataVendor?.Division || "",
            label: dataVendor?.DivisionName || "", // Provide the label property
          });
          setValue("PaymentTerms", {
            value: dataVendor?.PaymentTerms || "",
            label: dataVendor?.PaymentTermsName || "", // Provide the label property
          });
          setValue("PaymenttermsRemarks", dataVendor?.PaymenttermsRemarks);

          setValue("OtherReason", dataVendor?.OtherReason);

          setValue("Email", dataVendor?.Email);
          setValue("MobileNo", dataVendor?.MobileNo);
          setValue("SupplierOrigin", dataVendor?.SupplierOrigin);
          //   setValue("SupplierSpecialization", dataVendor?.SupplierSpecialization);
          setValue("CompanyName", {
            value: dataVendor?.SupplierRepositoryRequestId || "",
            label: dataVendor?.VendorName || "", // Provide the label property
          });
          // setValue("OtherSupplierSpecialization", (dataVendor?.OtherSpecialization && dataVendor?.OtherSpecializationName) ? {
          //   value: dataVendor?.OtherSpecialization ,
          //   label: dataVendor?.OtherSpecializationName , // Provide the label property
          // }: null);
          setValue("OtherSupplierSpecialization", (dataVendor?.OtherSupplierSpecialization && dataVendor?.OtherSupplierSpecializationName) ? {
            value: dataVendor?.OtherSupplierSpecialization,
            label: dataVendor?.OtherSupplierSpecializationName, // Provide the label property
          } : null);
          setValue("SupplierSpecialization", {
            value: dataVendor?.SupplierSpecialization || "",
            label: dataVendor?.SupplierSpecializationName || "", // Provide the label property
          });
          setValue("ContactPersonName", dataVendor?.ContactPersonName);
          setValue(
            "ContactPersonDesignation",
            dataVendor?.ContactPersonDesignation
          );
          setValue("SupplierOriginSources", {
            value: dataVendor?.SupplierOriginSources || "",
            label: dataVendor?.SupplierOriginSourcesName || "", // Provide the label property
          });
          setValue("CommercialReason", {
            value: dataVendor?.SupplierOriginSources || "",
            label: dataVendor?.CommercialReasonName || "", // Provide the label property
          });

          setValue("VendorName", dataVendor?.VendorName);
          setSupplierOrigin(`${dataVendor?.SupplierOrigin}`);
          setValue("ExpectedBusiness", dataVendor?.ExpectedBusiness);

          setValue(
            "NewBusinessVertical",
            dataVendor?.NewBusinessVertical.toString()
          );
          setValue(
            "Importlocalization",
            dataVendor?.Importlocalization.toString()
          );
          setValue(
            "DuetoSingleSource",
            dataVendor?.DuetoSingleSource.toString()
          );
          setValue("CostSaving", dataVendor?.CostSaving.toString());

          setValue("Other", dataVendor?.Other.toString());

          setValue("Commercial", dataVendor?.Commercial.toString());
          setValue(
            "ExistingSupplierAvialableAndDiscussion",
            dataVendor?.ExistingSupplierAvialableAndDiscussion.toString()
          );
          setValue(
            "DiscussionWithNDTTeam",
            dataVendor?.DiscussionWithNDTTeam.toString()
          );
          setValue(
            "DiscussionWithNDTTeamComment",
            dataVendor?.DiscussionWithNDTTeamComment
          );

          setValue(
            "NewLocationAddedByExistingSupplierComment",
            dataVendor?.NewLocationAddedByExistingSupplierComment
          );

          setValue(
            "NewLocationAddedByExistingSupplier",
            dataVendor?.NewLocationAddedByExistingSupplier.toString()
          );

          setValue(
            "ExistingSupplierAvialableAndDiscusionComment",
            dataVendor?.ExistingSupplierAvialableAndDiscusionComment
          );
          setValue(
            "ReplacementExistingVendor",
            dataVendor?.ReplacementExistingVendor.toString()
          );
          setValue(
            "ReplacementofExistingVendorCode",
            dataVendor?.ReplacementofExistingVendorCode
          );
          if (dataVendor?.ReplacementofExistingVendorCode) {
            setIsSupplierCodeValid(true)
          }
          setValue("ExistingPaymentTerms", dataVendor?.ExistingPaymentTerms);
          setValue("EstablishmentRemarks", dataVendor?.EstablishmentRemarks);
          setValue(
            "HowMuchAnnuallyCostSaving",
            dataVendor?.HowMuchAnnuallyCostSaving
          );
          setValue(
            "WhatPercentAnnuallyCostSaving",
            dataVendor?.WhatPercentAnnuallyCostSaving
          );
          setValue("CostSheet", dataVendor?.CostSheet.toString());
          setValue(
            "SupplierServiceDescription",
            dataVendor?.SupplierServiceDescription
          );
          setValue(
            "ExistingSupplierFeedback",
            dataVendor?.ExistingSupplierFeedback
          );

          setValue(
            "EstimatedStartOfSuppies",
            dataVendor?.EstimatedStartOfSuppies
          );

          setValue("CompanyProfileWebsite", dataVendor?.CompanyProfileWebsite);
          setValue("Remarks", dataVendor?.Remarks);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
    if (sendToApiPotentialData?.value) {
      // alert("sendToApiPotentialData")
      getUser(sendToApiPotentialData?.value)
        .then(async (res) => {
          const userData = res?.Data;
          const dataForSupplier = { ...userData[0] };
          setIsExceptionalSupplier(dataForSupplier?.IsExceptionalSupplier);
          setDownloadButtonForSupplier(dataForSupplier)
          getSelectSupplierCategory(dataForSupplier);
          setIdByDataInSupplierNeedForm(dataForSupplier);
          void handleCountryChange(dataForSupplier?.Country, false);
          void handleStateChange(dataForSupplier?.State, false);
          // void handleDistrictChange(dataForSupplier?.District, false);
          void handleCategoryDivisionMaster(dataForSupplier?.Category, false);
          setSupplierOrigin(dataForSupplier?.SupplierOrigin);
          setValue("YearOfBusinessIncorporation", {
            value: dataForSupplier?.YearOfBusinessIncorporationId || "",
            label: dataForSupplier?.YearOfBusinessIncorporationName,
          });
          setValue("OtherSupplierSpecialization", (dataForSupplier?.OtherSpecialization && dataForSupplier?.OtherSpecializationName) ? {
            value: dataForSupplier?.OtherSpecialization,
            label: dataForSupplier?.OtherSpecializationName, // Provide the label property
          } : null);
          setSelectedYear(dataForSupplier?.YearOfBusinessIncorporationName);
          setCompanyProfile({
            fileName: dataForSupplier?.CompanyProfileAttachmentName,
            base64String: "",
            fileType: "",
          });
          setSaveRiskFile({
            fileName: dataForSupplier?.RiskAssessmentDocumentAttachment,
            base64String: "",
            fileType: "",
          });
          // setValue("CompanyProfileWebsite", dataForSupplier?.CompanyProfileWebsite)
          setValue("SupplierOriginSources", {
            value: dataForSupplier?.HowDidYouHearAboutUsId || "",
            label: dataForSupplier?.HowDidYouHearAboutUsName || "", // Provide the label property
          });
          setValue("SupplierSpecialization", {
            value: dataForSupplier?.SupplierSpecialization || "",
            label: dataForSupplier?.SpecializationName || "", // Provide the label property
          });
          setValue("Country", {
            value: dataForSupplier?.CountryId || "",
            label: dataForSupplier?.CountryName || "", // Provide the label property
          });
          setValue("State", {
            value: dataForSupplier?.StateId || "",
            label: dataForSupplier?.StateName || "", // Provide the label property
          });
          setValue("District", dataForSupplier?.DistrictName);
          setValue("City", dataForSupplier?.CityName);
          setValue(
            "ContactPersonDesignation",
            dataForSupplier?.ContactPersonDesignation
          );
          setValue("ContactPersonName", dataForSupplier?.ContactPersonName);

          setSupplierOrigin(`${dataForSupplier?.SupplierOrigin}`);
          setValue("VendorName", dataForSupplier?.CompanyName);
          setValue("MobileNo", dataForSupplier?.ContactNumber);
          setValue("Email", dataForSupplier?.Email);
          setValue(
            "CompanyProfileAttachmentName",
            dataForSupplier?.CompanyProfileAttachmentName
          );
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [sendToApiPotentialData?.value, supplierId, VendorRegID]);
  const handleDownload = (file) => {
    if (file) {
      // Create a hidden anchor element to trigger the download
      const link = document.createElement("a");

      if (typeof file === "string") {
        // If it's a string and starts with 'http', assume it's a URL
        link.href = file;

      } else {
        // Handle other cases or throw an error

        return;
      }

      link.target = "_blank";
      link.download = "downloadedFile";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const handleCostSheetDocumentDelete = () => {
    setIsoFile((p) => ({
      ...p,
      isRemove: true,
    }));
  };
  const handleUploadEvidenceDelete = () => {
    setUploadEvidenceFile((p) => ({
      ...p,
      isRemove: true,
    }));
  };
  const handleCompanyProfileDelete = () => {
    setCompanyProfile((p) => ({
      ...p,
      isRemove: true,
    }));
  };

  const handleSaveRiskDelete = () => {
    setSaveRiskFile((p) => ({
      ...p,
      isRemove: true,
    }));
  };
  const onPopupConfirm = async () => {
    setPopupLoader(true); // Start loader
    dispatch(
      saveNewSupplier(dataForSelfAssesmentRequired, async (res) => {
        setPopupLoader(false); // Stop loader regardless of success or failure
        if (res && res.IsSuccessful) {
          setShowPopup(false); // Close the popup if submission is successful
          Toaster.success(res?.Data?.Message);
          history.push("/vendor-need-list");
        } else if (res?.response?.data?.ErrorMessage) {
          setSetDisable(false);
        }
      })
    );
  };

  const handleSupplierRadioChange = (event) => {
    // setShowSupplierOriginPopup(true);
    setSupplierOrigin(event.target.id);
  };

  const onConfirmSupplierPopup = (event) => {
    setShowSupplierOriginPopup(false);
    // Any other logic you want to perform on confirmation
  };
  const dispatch = useDispatch();
  const getTypeOfEstablishment = () => {
    getTypeEstablishment()
      .then((res) => {
        setEstablishment(res?.Data);
      })
      .catch(() => { });
  };

  const handleYearChange = (year, emptyOther = true) => {
    setSelectedYear(year?.label || year);
    if (emptyOther) {
      setValue("EstablishmentRemarks", null);

    }
  };
  const getYearOfBuisnessCorporation = () => {
    getYearOfBuisnessService()
      .then((res) => {
        setYearOfBuisness(res?.Data);
      })
      .catch(() => { });
  };
  const getCountryMasterList = () => {
    getCountryService()
      .then((res) => {
        setCountryList(res?.Data);
      })
      .catch(() => { });
  };
  const getSelectSupplierNeedForm = () => {
    getSelectSupplierService()
      .then((res) => {
        setSelectedpotentialSupplierList(res?.Data);
      })
      .catch(() => { });
  };
  const getSelectSupplierNeedFormPlant = () => {
    getSelectSupplierPlant()
      .then((res) => {
        setSelectedpotentialSupplierListPlant(res?.Data);
      })
      .catch(() => { });
  };
  const getSelectSupplierCategory = (data) => {
    getSelectSupplierCategoryService(
      data?.IsExceptionalSupplier
    )
      .then((res) => {
        setSelectedCategory(res?.Data);
      })
      .catch(() => { });
  };
  const getAllSupplierSpecialization = () => {
    getAllSupplierSpecializationService()
      .then((res) => {
        setSupplierSpecialization(res?.Data);
      })
      .catch(() => { });
  };
  const getPaymentTermsOfVendorNeedForm = () => {
    getPaymentTermsService()
      .then((res) => {
        setPaymentTermsMaster(res?.Data);
      })
      .catch(() => { });
  };
  const getOriginOfSourceRef = () => {
    getSourceOfOrigin()
      .then((res) => {
        setSourceOfOriginList(res?.Data);
      })
      .catch(() => { });
  };
  const getCommercialReasonOfVendorNeedForm = () => {
    getCommercialReasonService()
      .then((res) => {
        setCommercialReasonMaster(res?.Data);
      })
      .catch(() => { });
  };
  // const handleEvidenceUpload = (file) => {
  //   // Check if the ile size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file?.size <= 5 * 1024 * 1024) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");
  //       // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
  //       const allowedFileTypes = [
  //         "application/pdf",
  //         "application/msword", // .doc files
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
  //         "application/vnd.ms-excel", // .xls files
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
  //       ];
  //       const isTypeValid = allowedFileTypes.includes(file.type);

  //       if (!isTypeValid) {
  //         Toaster.error(
  //           "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX),Excel (XLS/XLSX)."
  //         );
  //         // Handle the case where the file type is not allowed

  //         return;
  //       }
  //       // Pass file name, base64String, and fileType to setGstinFile
  //       setUploadEvidenceFile({
  //         fileName: file?.name,
  //         base64String,
  //         fileType: file?.type,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //     // Handle the case where the file size exceeds 5 MB or the file type is not allowed
  //   }
  // };

  // const handleCostSheetDocument = (file) => {
  //   // Allowed file types for cost sheet document
  //   const allowedFileTypes = [
  //     "application/pdf",
  //     "application/msword", // .doc files
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
  //     "application/vnd.ms-excel", // .xls files
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
  //   ];

  //   // Check if the file type is allowed
  //   if (!allowedFileTypes.includes(file.type)) {
  //     Toaster.error(
  //       "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX),Excel (XLS/XLSX)."
  //     );
  //     // Unsupported file type

  //     return; // Exit the function if file type is not allowed
  //   }

  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size > 5 * 1024 * 1024) {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //     // File size exceeds 5 MB

  //     return; // Exit the function if file size is too large
  //   }

  //   // Proceed with reading the file if both conditions are met
  //   const reader = new FileReader();

  //   reader.onload = (event) => {
  //     if (event.target?.result) {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");

  //       // Set the cost sheet document details
  //       setIsoFile({ fileName: file.name, base64String, fileType: file.type });
  //       setValue("CostSheetDocument", {
  //         fileName: file?.name,
  //         base64String,
  //         fileType: file?.type,
  //       })
  //       trigger('CostSheetDocument')
  //     }
  //   };

  //   // Read the file as a Data URL
  //   reader.readAsDataURL(file);
  // };

  // const handleComapnayProfileUpload = (file) => {
  //   // Allowed file types for company profile upload
  //   const allowedFileTypes = [
  //     "application/pdf",
  //     "application/msword", // .doc (Word)
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx (Word)
  //     "image/jpeg",
  //     "image/jpg",
  //     "image/png",
  //     "application/vnd.ms-excel", // .xls (Excel)
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel)
  //     "application/vnd.ms-powerpoint", // .ppt (PowerPoint)
  //     "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx (PowerPoint)
  //   ];

  //   // Check if the file type is allowed
  //   if (!allowedFileTypes.includes(file.type)) {
  //     Toaster.error(
  //       "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Image (JPEG/JPG/PNG), Excel (XLS/XLSX), PowerPoint (PPT/PPTX)."
  //     );
  //     // Unsupported file type

  //     return; // Exit the function if file type is not allowed
  //   }

  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size > 5 * 1024 * 1024) {
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
  //     // File size exceeds 5 MB

  //     return; // Exit the function if file size is too large
  //   }

  //   // Proceed with reading the file if both conditions are met
  //   const reader = new FileReader();

  //   reader.onload = (event) => {
  //     if (event.target?.result) {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");

  //       // Set the company profile file details
  //       setCompanyProfile({
  //         fileName: file.name,
  //         base64String,
  //         fileType: file.type,
  //       });
  //     }
  //   };

  //   // Read the file as a Data URL
  //   reader.readAsDataURL(file);
  // };

  // const handleSaveRiskUpload = (file) => {
  //   // Allowed file types for saving risk upload
  //   const allowedFileTypes = [
  //     "application/pdf",
  //     "application/msword", // .doc (Word)
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx (Word)
  //     "image/jpeg",
  //     "image/jpg",
  //     "image/png",
  //     "application/vnd.ms-excel", // .xls (Excel)
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel)
  //     "application/vnd.ms-powerpoint", // .ppt (PowerPoint)
  //     "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx (PowerPoint)
  //   ];

  //   // Check if the file type is allowed
  //   if (!allowedFileTypes.includes(file.type)) {
  //     // Unsupported file type
  //     Toaster.error(
  //       "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Image (JPEG/JPG/PNG), Excel (XLS/XLSX), or PowerPoint (PPT/PPTX)."
  //     );

  //     return; // Exit the function if file type is not allowed
  //   }

  //   // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
  //   if (file.size > 5 * 1024 * 1024) {
  //     // File size exceeds 5 MB
  //     Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");

  //     return; // Exit the function if file size is too large
  //   }

  //   // Proceed with reading the file if both conditions are met
  //   const reader = new FileReader();

  //   reader.onload = (event) => {
  //     if (event.target?.result) {
  //       let base64String = event.target.result;

  //       // Remove the data type prefix
  //       base64String = base64String.replace(/^data:(.*?);base64,/, "");

  //       // Set the save risk file details
  //       setSaveRiskFile({
  //         fileName: file.name,
  //         base64String,
  //         fileType: file.type,
  //       });
  //     }
  //   };

  //   // Read the file as a Data URL
  //   reader.readAsDataURL(file);
  // };
  const handleEvidenceUpload = (file) => {
    try {
      // Check for spaces and special characters in filename
      const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
      const hasSpaces = /\s/.test(file.name);

      if (hasSpaces || hasSpecialChars) {
        Toaster.error(
          "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
        );
        return;
      }

      // Check file size first (5MB limit)
      if (file?.size > 5 * 1024 * 1024) {
        Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
        return;
      }

      // Check allowed file types
      const allowedFileTypes = [
        "application/pdf",
        "application/msword", // .doc files
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
        "application/vnd.ms-excel", // .xls files
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
      ];

      if (!allowedFileTypes.includes(file.type)) {
        Toaster.error(
          "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Excel (XLS/XLSX)."
        );
        return;
      }

      // Proceed with file reading if all validations pass
      const reader = new FileReader();

      reader.onload = (event) => {
        if (event.target?.result) {
          let base64String = event.target.result;
          // Remove the data type prefix
          base64String = base64String.replace(/^data:(.*?);base64,/, "");

          setUploadEvidenceFile({
            fileName: file.name,
            base64String,
            fileType: file.type,
          });
        }
      };

      reader.onerror = () => {
        Toaster.error("Error uploading file, please connect with your IT team");
      };

      reader.readAsDataURL(file);

    } catch (error) {
      Toaster.error("Error uploading file, please connect with your IT team");

    }
  };

  const handleCostSheetDocument = (file) => {
    // Allowed file types for cost sheet document
    const allowedFileTypes = [
      "application/pdf",
      "application/msword", // .doc files
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
      "application/vnd.ms-excel", // .xls files
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
    ];

    try {
      // Check for spaces and special characters in filename
      const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
      const hasSpaces = /\s/.test(file.name);

      if (hasSpaces || hasSpecialChars) {
        Toaster.error(
          "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
        );
        return;
      }

      // Check if the file type is allowed
      if (!allowedFileTypes.includes(file.type)) {
        Toaster.error(
          "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Excel (XLS/XLSX)."
        );
        return;
      }

      // Check if the file size is less than or equal to 5 MB
      if (file.size > 5 * 1024 * 1024) {
        Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
        return;
      }

      // Proceed with reading the file if all conditions are met
      const reader = new FileReader();

      reader.onload = (event) => {
        if (event.target?.result) {
          let base64String = event.target.result;
          // Remove the data type prefix
          base64String = base64String.replace(/^data:(.*?);base64,/, "");

          // Set the cost sheet document details
          setIsoFile({
            fileName: file.name,
            base64String,
            fileType: file.type
          });

          setValue("CostSheetDocument", {
            fileName: file.name,
            base64String,
            fileType: file.type,
          });

          trigger('CostSheetDocument');
        }
      };

      reader.onerror = () => {
        Toaster.error("Error uploading file, please connect with your IT team");
      };

      // Read the file as a Data URL
      reader.readAsDataURL(file);

    } catch (error) {
      Toaster.error("Error uploading file, please connect with your IT team");

    }
  };

  const handleComapnayProfileUpload = (file) => {
    // Allowed file types for company profile upload
    const allowedFileTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ];

    try {
      // Check if file name contains spaces
      const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
      const hasSpaces = /\s/.test(file.name);

      if (hasSpaces || hasSpecialChars) {
        Toaster.error(
          "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
        );
        return;
      }

      // Check if the file type is allowed
      if (!allowedFileTypes.includes(file.type)) {
        Toaster.error(
          "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Image (JPEG/JPG/PNG), Excel (XLS/XLSX), PowerPoint (PPT/PPTX)."
        );
        return;
      }

      // Check if the file size is less than or equal to 5 MB
      if (file.size > 5 * 1024 * 1024) {
        Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
        return;
      }

      // Proceed with reading the file if all conditions are met
      const reader = new FileReader();

      reader.onload = (event) => {
        if (event.target?.result) {
          let base64String = event.target.result;
          base64String = base64String.replace(/^data:(.*?);base64,/, "");

          setCompanyProfile({
            fileName: file.name,
            base64String,
            fileType: file.type,
          });
        }
      };

      reader.onerror = () => {
        Toaster.error("Error uploading file, please connect with your IT team");
      };

      reader.readAsDataURL(file);

    } catch (error) {
      Toaster.error("Error uploading file, please connect with your IT team");

    }
  };
  const handleSaveRiskUpload = (file) => {
    // Allowed file types for saving risk upload
    const allowedFileTypes = [
      "application/pdf",
      "application/msword", // .doc (Word)
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx (Word)
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/vnd.ms-excel", // .xls (Excel)
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel)
      "application/vnd.ms-powerpoint", // .ppt (PowerPoint)
      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx (PowerPoint)
    ];

    try {
      // Check for spaces and special characters in filename
      const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
      const hasSpaces = /\s/.test(file.name);

      if (hasSpaces || hasSpecialChars) {
        Toaster.error(
          "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
        );
        return;
      }

      // Check if the file type is allowed
      if (!allowedFileTypes.includes(file.type)) {
        Toaster.error(
          "Unsupported file type. Please choose a file with one of the following formats: PDF, Word (DOC/DOCX), Image (JPEG/JPG/PNG), Excel (XLS/XLSX), or PowerPoint (PPT/PPTX)."
        );
        return;
      }

      // Check if the file size is less than or equal to 5 MB
      if (file.size > 5 * 1024 * 1024) {
        Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
        return;
      }

      // Proceed with reading the file if all conditions are met
      const reader = new FileReader();

      reader.onload = (event) => {
        if (event.target?.result) {
          let base64String = event.target.result;
          // Remove the data type prefix
          base64String = base64String.replace(/^data:(.*?);base64,/, "");

          // Set the save risk file details
          setSaveRiskFile({
            fileName: file.name,
            base64String,
            fileType: file.type,
          });
        }
      };

      reader.onerror = () => {
        Toaster.error("Error uploading file, please connect with your IT team");
      };

      // Read the file as a Data URL
      reader.readAsDataURL(file);

    } catch (error) {
      Toaster.error("Error uploading file, please connect with your IT team");

    }
  };
  /**
   * @method renderListing
   * @description RENDER LISTING IN DROPDOWN
   */
  const renderListing = (label) => {
    if (label === "CompanyName") {
      return selectedPotentialSupplierList.map((potentialSupplierData) => ({
        value: potentialSupplierData.Id,
        label: potentialSupplierData.SupplierName,
      }));
    }
    if (label === "PlantData") {
      return selectedPotentialSupplierListPlant?.map((plantData) => ({
        value: plantData.Id,
        label: plantData.PlantName,
      }));
    }
    if (label === "CategoryData") {
      return selectedCategory.map((category) => ({
        value: category.Id,
        label: category.Name,
      }));
    }
    if (label === "SupplierSpecializationData") {
      return supplierSpecialization?.map((supplierSpecialization) => ({
        value: supplierSpecialization.Id,
        label: supplierSpecialization.SpecializationName,
      }));
    }
    if (label === "PaymentTermsData") {
      return paymentTermsMaster?.map((paymentterms) => ({
        value: paymentterms.Id,
        label: paymentterms.Name,
      }));
    }
    if (label === "yearOfBuisness") {
      return yearOfBuisness.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "SupplierOriginResources") {
      return sourceOfOriginList.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.SourceName,
      }));
    }

    if (label === "commercialReasonMasterData") {
      return commercialReasonMaster?.map((commercialReasonMaster) => ({
        value: commercialReasonMaster.Id,
        label: commercialReasonMaster.Name,
      }));
    }
    if (label === "currencyList") {
      return masterCurrencyList.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.PCId,
        label: yearOfBuisnessIncorporation.CurrencyName,
      }));
    }
    if (label === "DivisionData") {
      return currencyScaleData?.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "Country") {
      // Check if supplier origin is set and remove India from the listing
      const filteredCountryList =
        supplierOrigin === "2"
          ? countryList.filter((country) => country.Name !== "India")
          : countryList;

      return filteredCountryList.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "State") {
      return stateOptionData.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "District") {
      return districtOptionData.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.Name,
      }));
    }
    if (label === "City") {
      return cityOptionData.map((yearOfBuisnessIncorporation) => ({
        value: yearOfBuisnessIncorporation.Id,
        label: yearOfBuisnessIncorporation.City,
      }));
    }
  };

  const handleSubmitClick = (data, e, isSent) => {
    handleSubmit(() => onSubmit(data, e, isSent))();
  };
  const handleSelectChange = (value) => {
    setSelectedEstablishmentType(value);
  };
  /**
   * @method cancel
   * @description used to Reset form
   */
  const cancel = () => {
    window.history.back();
  };
  // const onSubmit = (data, e, isSent) => {
  //   // setSetDisable(true);

  //   let replacementofExistingVendorCode = data?.ReplacementofExistingVendorCode;
  //   let replacementExistingVendor = data?.ReplacementExistingVendor;
  //   if (!isSupplierCodeValid && replacementofExistingVendorCode && replacementExistingVendor === "true") {
  //     setError('ReplacementofExistingVendorCode', {
  //       type: 'manual',
  //       message: "Invalid supplier code.",
  //     });
  //     return;
  //   }
  //   const userDetail = userDetails();
  //   let otherSpecializationString = '';
  //   if (Array.isArray(data?.OtherSupplierSpecialization)) {
  //     otherSpecializationString = data.OtherSupplierSpecialization.map(item => item.value).join(",");
  //   } else if (data?.OtherSupplierSpecialization?.value) {
  //     otherSpecializationString = String(data.OtherSupplierSpecialization.value);
  //   }
  //   const payload = {
  //     VendorName: data?.VendorName,
  //     CompanyName: data?.CompanyName?.value,
  //     Plant: String(data?.Plant?.value),
  //     Category: data?.Category?.value,
  //     Division: data?.Division?.value,
  //     OtherSupplierSpecialization: otherSpecializationString,
  //     SupplierSpecialization: idDataFromSupplier?.SupplierSpecialization || dataVendorRegistrationIdData?.SupplierSpecialization || downloadButtonForSupplier?.SupplierSpecialization,
  //     SupplierOrigin: supplierOrigin,
  //     VendorRelation: true,
  //     SupplierOriginSources: data?.SupplierOriginSources?.value,
  //     ContactPersonName: data?.ContactPersonName,
  //     EstablishmentRemarks: data?.EstablishmentRemarks,
  //     ContactPersonDesignation: data?.ContactPersonDesignation,
  //     YearOfBusinessIncorporation: data?.YearOfBusinessIncorporation?.value,
  //     PaymenttermsRemarks: data?.PaymenttermsRemarks,
  //     costSavingDocument: uploadEvidenceFile?.base64String
  //       ? uploadEvidenceFile
  //       : uploadEvidenceFile.isRemove
  //         ? {
  //           fileName: dataVendorRegistrationIdData?.CostSavingDocumentUrl,
  //           base64String: "",
  //           fileType: "",
  //         }
  //         : null,
  //     PaymentTerms: data?.PaymentTerms?.value,
  //     VendorCompanyProfileDocument: companyProfile?.base64String
  //       ? companyProfile
  //       : companyProfile.isRemove
  //         ? {
  //           fileName: dataVendorRegistrationIdData?.CompanyProfileDocumentUrl,
  //           base64String: "",
  //           fileType: "",
  //         }
  //         : null,
  //     saveriskDocument: saveRiskFile?.base64String
  //       ? saveRiskFile
  //       : saveRiskFile.isRemove
  //         ? {
  //           fileName: dataVendorRegistrationIdData?.SaveriskDocumentUrl,
  //           base64String: "",
  //           fileType: "",
  //         }
  //         : null,
  //     costSheetDocument: isoFile?.base64String
  //       ? isoFile
  //       : isoFile.isRemove
  //         ? {
  //           fileName: dataVendorRegistrationIdData?.CostSheetDocumentUrl,
  //           base64String: "",
  //           fileType: "",
  //         }
  //         : null,
  //     MobileNo: data?.MobileNo,
  //     Email: data?.Email,
  //     Country: data?.Country?.value,
  //     State: data?.State?.value,
  //     District: data?.District,
  //     City: data?.City,
  //     NewBusinessVertical: data?.NewBusinessVertical === "true",
  //     Importlocalization: data?.Importlocalization === "true",
  //     DuetoSingleSource: data?.DuetoSingleSource === "true",
  //     CostSaving: data?.CostSaving === "true",
  //     CostSheet: data?.CostSheet === "true",
  //     ReplacementExistingVendor: data?.ReplacementExistingVendor === "true",
  //     ReplacementofExistingVendorCode: data?.ReplacementofExistingVendorCode,
  //     ExistingPaymentTerms: data?.ExistingPaymentTerms,
  //     Commercial: data?.Commercial,
  //     CommercialReason: data?.CommercialReason?.value,
  //     Other: data?.Other === "true",
  //     OtherReason: data?.OtherReason,
  //     CompanyProfileWebsite: data?.CompanyProfileWebsite,
  //     SupplierServiceDescription: data?.SupplierServiceDescription,
  //     ExistingSupplierAvialableAndDiscussion:
  //       data?.ExistingSupplierAvialableAndDiscussion === "true",
  //     ExistingSupplierAvialableAndDiscusionComment:
  //       data?.ExistingSupplierAvialableAndDiscusionComment,
  //     ExistingSupplierFeedback: data?.ExistingSupplierFeedback,
  //     DiscussionWithNDTTeam: data?.DiscussionWithNDTTeam === "true",
  //     DiscussionWithNDTTeamComment: data?.DiscussionWithNDTTeamComment,
  //     LocationChangeOfExistingSupplier:
  //       0,
  //     NewLocationAddedByExistingSupplier:
  //       data?.NewLocationAddedByExistingSupplier === "true",
  //     NewLocationAddedByExistingSupplierComment:
  //       data?.NewLocationAddedByExistingSupplierComment,
  //     Remarks: remarks,
  //     HowMuchAnnuallyCostSaving: parseInt(data?.HowMuchAnnuallyCostSaving),
  //     WhatPercentAnnuallyCostSaving: parseInt(
  //       data?.WhatPercentAnnuallyCostSaving
  //     ),
  //     EstimatedStartOfSuppies: data?.EstimatedStartOfSuppies,
  //     ExpectedBusiness: parseInt(data.ExpectedBusiness),
  //     EmployeeId: parseInt(userDetail?.EmployeeId),
  //     SupplierRepositoryRequestId: sendToApiPotentialData?.value || supplierId,
  //   };

  //   if (supplierId) {
  //     if (isSelfAssesmentRequired) {
  //       setShowPopup(true);
  //       setDataForSelfAssesmentRequired(payload);
  //     } else {
  //       dispatch(
  //         saveNewSupplier(payload, async (res) => {
  //           setSetDisable(true);
  //           if (res) {
  //             if (res && res?.IsSuccessful) {
  //               setSetDisable(false);
  //               Toaster.success(res?.Data?.Message);
  //               history.push("/vendor-need-list");
  //             } else if (res?.response?.data?.ErrorMessage) {
  //               setSetDisable(false);
  //             }
  //           }
  //         })
  //       );
  //     }
  //   } else if (VendorRegID) {
  //     setSetDisable(true);
  //     const reqData = {
  //       ...payload,
  //       VendorRequirementRegistrationId: VendorRegID,
  //     };
  //     dispatch(
  //       saveNewSupplier(reqData, (res) => {
  //         if (res && res?.IsSuccessful) {
  //           setSetDisable(false);
  //           Toaster.success(res?.Data?.Message);
  //           history.push("/vendor-need-list");
  //         } else {
  //         }
  //       })
  //     );
  //   } else {
  //     if (isSelfAssesmentRequired) {
  //       setShowPopup(true);
  //       setDataForSelfAssesmentRequired(payload);
  //     } else {
  //       setSetDisable(true);
  //       dispatch(
  //         saveNewSupplier(payload, async (res) => {
  //           if (res && res?.IsSuccessful) {
  //             setSetDisable(false);
  //             Toaster.success(res?.Data?.Message);
  //             history.push("/vendor-need-list");
  //           } else if (res?.response?.data?.ErrorMessage) {
  //             setSetDisable(false);
  //           }
  //         })
  //       ).catch((error) => {
  //         setSetDisable(false);
  //         Toaster.error(error?.response?.data?.ErrorMessage);
  //       });
  //     }
  //   }
  // };
  const onSubmit = (data, e, isSent) => {
    // Start loader
    setSetDisable(true);

    let replacementofExistingVendorCode = data?.ReplacementofExistingVendorCode;
    let replacementExistingVendor = data?.ReplacementExistingVendor;

    if (!isSupplierCodeValid && replacementofExistingVendorCode && replacementExistingVendor === "true") {
      setError('ReplacementofExistingVendorCode', {
        type: 'manual',
        message: "Invalid supplier code.",
      });
      setSetDisable(false);
      return;
    }

    const userDetail = userDetails();
    let otherSpecializationString = '';

    if (Array.isArray(data?.OtherSupplierSpecialization)) {
      otherSpecializationString = data.OtherSupplierSpecialization.map(item => item.value).join(",");
    } else if (data?.OtherSupplierSpecialization?.value) {
      otherSpecializationString = String(data.OtherSupplierSpecialization.value);
    }

    const payload = {
      VendorName: data?.VendorName,
      CompanyName: data?.CompanyName?.value,
      Plant: String(data?.Plant?.value),
      Category: data?.Category?.value,
      Division: data?.Division?.value,
      OtherSupplierSpecialization: otherSpecializationString,
      SupplierSpecialization: idDataFromSupplier?.SupplierSpecialization || dataVendorRegistrationIdData?.SupplierSpecialization || downloadButtonForSupplier?.SupplierSpecialization,
      SupplierOrigin: supplierOrigin,
      VendorRelation: vendorRelation == 1 ? "true" : "false",
      SupplierOriginSources: data?.SupplierOriginSources?.value,
      ContactPersonName: data?.ContactPersonName,
      EstablishmentRemarks: data?.EstablishmentRemarks,
      ContactPersonDesignation: data?.ContactPersonDesignation,
      YearOfBusinessIncorporation: data?.YearOfBusinessIncorporation?.value,
      PaymenttermsRemarks: data?.PaymenttermsRemarks,
      costSavingDocument: uploadEvidenceFile?.base64String
        ? uploadEvidenceFile
        : uploadEvidenceFile.isRemove
          ? {
            fileName: dataVendorRegistrationIdData?.CostSavingDocumentUrl,
            base64String: "",
            fileType: "",
          }
          : null,
      PaymentTerms: data?.PaymentTerms?.value,
      VendorCompanyProfileDocument: companyProfile?.base64String
        ? companyProfile
        : companyProfile.isRemove
          ? {
            fileName: dataVendorRegistrationIdData?.CompanyProfileDocumentUrl,
            base64String: "",
            fileType: "",
          }
          : null,
      saveriskDocument: saveRiskFile?.base64String
        ? saveRiskFile
        : saveRiskFile.isRemove
          ? {
            fileName: dataVendorRegistrationIdData?.SaveriskDocumentUrl,
            base64String: "",
            fileType: "",
          }
          : null,
      costSheetDocument: isoFile?.base64String
        ? isoFile
        : isoFile.isRemove
          ? {
            fileName: dataVendorRegistrationIdData?.CostSheetDocumentUrl,
            base64String: "",
            fileType: "",
          }
          : null,
      MobileNo: data?.MobileNo,
      Email: data?.Email,
      Country: data?.Country?.value,
      State: data?.State?.value,
      District: data?.District,
      City: data?.City,
      NewBusinessVertical: data?.NewBusinessVertical === "true",
      Importlocalization: data?.Importlocalization === "true",
      DuetoSingleSource: data?.DuetoSingleSource === "true",
      CostSaving: data?.CostSaving === "true",
      CostSheet: data?.CostSheet === "true",
      ReplacementExistingVendor: data?.ReplacementExistingVendor === "true",
      ReplacementofExistingVendorCode: data?.ReplacementofExistingVendorCode,
      ExistingPaymentTerms: data?.ExistingPaymentTerms,
      Commercial: data?.Commercial,
      CommercialReason: data?.CommercialReason?.value,
      Other: data?.Other === "true",
      OtherReason: data?.OtherReason,
      CompanyProfileWebsite: data?.CompanyProfileWebsite,
      SupplierServiceDescription: data?.SupplierServiceDescription,
      ExistingSupplierAvialableAndDiscussion: data?.ExistingSupplierAvialableAndDiscussion === "true",
      ExistingSupplierAvialableAndDiscusionComment: data?.ExistingSupplierAvialableAndDiscusionComment,
      ExistingSupplierFeedback: data?.ExistingSupplierFeedback,
      DiscussionWithNDTTeam: data?.DiscussionWithNDTTeam === "true",
      DiscussionWithNDTTeamComment: data?.DiscussionWithNDTTeamComment,
      LocationChangeOfExistingSupplier: 0,
      NewLocationAddedByExistingSupplier: data?.NewLocationAddedByExistingSupplier === "true",
      NewLocationAddedByExistingSupplierComment: data?.NewLocationAddedByExistingSupplierComment,
      Remarks: remarks,
      HowMuchAnnuallyCostSaving: parseInt(data?.HowMuchAnnuallyCostSaving),
      WhatPercentAnnuallyCostSaving: parseInt(data?.WhatPercentAnnuallyCostSaving),
      EstimatedStartOfSuppies: data?.EstimatedStartOfSuppies,
      ExpectedBusiness: parseInt(data.ExpectedBusiness),
      EmployeeId: parseInt(userDetail?.EmployeeId),
      SupplierRepositoryRequestId: sendToApiPotentialData?.value || supplierId,
    };

    if (supplierId) {
      if (isSelfAssesmentRequired) {
        setShowPopup(true);
        setDataForSelfAssesmentRequired(payload);
        setSetDisable(false);
      } else {
        dispatch(
          saveNewSupplier(payload, async (res) => {
            if (res) {
              if (res && res?.IsSuccessful) {
                setSetDisable(false);
                Toaster.success(res?.Data?.Message);
                history.push("/vendor-need-list");
              } else if (res?.response?.data?.ErrorMessage) {
                setSetDisable(false);
              }
            }
          })
        );
      }
    } else if (VendorRegID) {
      const reqData = {
        ...payload,
        VendorRequirementRegistrationId: VendorRegID,
      };
      dispatch(
        saveNewSupplier(reqData, (res) => {
          if (res && res?.IsSuccessful) {
            setSetDisable(false);
            Toaster.success(res?.Data?.Message);
            history.push("/vendor-need-list");
          } else {
            setSetDisable(false);
          }
        })
      );
    } else {
      if (isSelfAssesmentRequired) {
        setShowPopup(true);
        setDataForSelfAssesmentRequired(payload);
        setSetDisable(false);
      } else {
        dispatch(
          saveNewSupplier(payload, async (res) => {
            if (res && res?.IsSuccessful) {
              setSetDisable(false);
              Toaster.success(res?.Data?.Message);
              history.push("/vendor-need-list");
            } else if (res?.response?.data?.ErrorMessage) {
              setSetDisable(false);
            }
          })
        ).catch((error) => {
          setSetDisable(false);
          Toaster.error(error?.response?.data?.ErrorMessage);
        });
      }
    }
  };
  async function handleCountryChange(selectedValue, emptyOther = true) {
    const stateRes = await getStateSelection(
      selectedValue?.value || selectedValue
    );
    setOptionData(stateRes?.Data?.StateList);
    if (emptyOther) {
      // setDistrictOptionData([]);

      setValue("State", null);
      // setValue("District", null);
      // setValue("City", null);
    }
  }

  async function handleStateChange(selectedValue, emptyOther = true) {
    const districtResponse = await getDistrictSelection(
      selectedValue?.value || selectedValue
    );
    setDistrictOptionData(districtResponse?.Data?.DistrictList);
    if (emptyOther) {
      // setCityOptionData([]);
      // setValue("District", null);
      // setValue("City", null);
    }
  }
  //   async function handleCategoryDivisionMaster(value, emptyOther = true) {
  //     let flagCheck=value?.value ? value?.value :value
  //     console.log('flagCheck: ', flagCheck);

  //     const selectedCat = selectedCategory?.find(
  //       (item) => item?.Id === flagCheck
  //     );
  // console.log(getDivisionByCategoryService, 'selectedCat');

  //     setSelectedCategoryCostSheet(selectedCat?.IsCostSheet?.toString())
  //     setIsSelfAssesmentRequired(selectedCat?.IsSelfAssessmentRequeired);
  //     setCheckDivison(selectedCat?.IsDivision);
  //     const currencyScaleRespose = await getDivisionByCategoryService(
  //       flagCheck
  //     );
  //     setCurrencyScaleData(currencyScaleRespose?.Data?.VendorCategory);
  //     if (emptyOther) {
  //       setValue("Division", null);
  //     }
  //   }
  const handleCategoryDivisionMaster = async (value, emptyOther = true) => {
    // Show loader when category changes
    setLoading(true);

    let categoryId = value?.value ? value?.value : value;

    const selectedCat = selectedCategory?.find(
      (item) => item?.Id === categoryId
    );
    console.log('selectedCat: ', selectedCat);
    // Set cost sheet requirement flag based on category selection
    const isCostSheetRequired = selectedCat?.IsCostSheet === true;
    setSelectedCategoryCostSheet(isCostSheetRequired ? "true" : "false");

    // Update form validation for CostSheetDocument based on requirement
    if (isCostSheetRequired) {
      setValue("CostSheet", "true");
    }

    setIsSelfAssesmentRequired(selectedCat?.IsSelfAssessmentRequeired);
    setCheckDivison(selectedCat?.IsDivision);

    try {
      const currencyScaleResponse = await getDivisionByCategoryService(categoryId);
      setCurrencyScaleData(currencyScaleResponse?.Data?.VendorCategory);

      if (emptyOther) {
        setValue("Division", null);
      }
    } catch (error) {
      console.error("Error fetching division data:", error);
      // Handle error if needed
    } finally {
      // Hide loader when done
      setLoading(false);
    }
  }
  const TrackApplicationMessage = () => {
    return (
      <div>
        <p>
          This action will send a Self-Assessment Filling Request
          <br /> to the supplier.
        </p>
        <p className="mt-2">Do you want to proceed?</p>
      </div>
    );
  };
  if (setDisable || popupLoader || loading) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }
  /**
   * @method render
   * @description Renders the component
   */
  const closeSupplierPopUp = () => {
    setShowSupplierOriginPopup(false);
  };
  const closeSelfAssesmentPopup = () => {
    setShowPopup(false);
    // history.push("/vendor-need-list");
  };

  const validateSupplierCode = async (supplierCode, notifyMsg = true) => {
    if (supplierCode) {
      setLoading(true);
      supplierCode = supplierCode.toUpperCase();
      let url = `${API.checkSupplierCodeIsValid}?vendorCode=${supplierCode}`;
      const request = axiosHelper.get(url);
      request
        .then((response) => {
          if (response.data.IsSuccessful) {
            setLoading(false);
            setIsSupplierCodeValid(true);
            if (notifyMsg) {
              notify.success(response.data.FriendlyMessage);
            }
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 400) {
            const responseData = error.response.data;
            if (!responseData.IsSuccessful) {
              setLoading(false);
              setIsSupplierCodeValid(false);
              setError("ReplacementofExistingVendorCode", {
                type: 'manual',
                message: responseData.ErrorMessage,
              });
              return false;
            }
          }
        });
    }
  };

  return (
    <>
      {/* {loading && <LoaderCustom customClass="simulation-Loader" />} */}
      <div className="container-fluid">
        <div className="signup-form">
          <div className="row">
            <div className="col-md-12">
              <div className="shadow-lgg login-formg">
                <Row className={`filter-row-large`}>
                  <Col md="4" className="mb-2">
                    <h1>{VendorRegID ? "Update Supplier Need Form" : "New Supplier Need Form"}</h1>
                  </Col>
                  <Col md="8" className="mb-3 d-flex justify-content-end">
                    {/* <button
                      type="button"
                      className={"apply mt-1"}
                      onClick={() => window.history.back()}
                    >
                      <div className={"back-icon"}></div>Back
                    </button> */}
                  </Col>
                </Row>
                {showPopup && (
                  <PopupMsgWrapper
                    firstButtonName="Proceed"
                    // secondButtonName={true}
                    header="Confirm"
                    isOpen={showPopup}
                    closePopUp={closeSelfAssesmentPopup}
                    confirmPopup={onPopupConfirm}
                    message={TrackApplicationMessage()}
                  // disableSecondButton={true}
                  ></PopupMsgWrapper>
                )}
                <div>
                  {showSupplierOriginPopup && (
                    <PopupMsgWrapper
                      header="Supplier Origin"
                      isOpen={showSupplierOriginPopup}
                      closePopUp={closeSupplierPopUp}
                      confirmPopup={onConfirmSupplierPopup}
                      message={
                        <>
                          Are you sure you want to change the origin to
                          Overseas?
                          <Alert
                            color="warning"
                            className="p-1 mt-3 hl-warning-msg"
                          >
                            Clicking the OK button will erase the form data on
                            the page.
                          </Alert>
                        </>
                      }
                    />
                  )}
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="part-detail-wrapper">
                      <Col
                        md="3"
                        className="d-flex aliging-items-center justify-content-between hl-title-tooltip"
                      >
                        <div className="hl-right-radio">
                          <div className="hl-title-tooltip d-flex">
                            <HeaderTitle
                              title={
                                <>
                                  Supplier Origin:
                                  <span className="asterisk-required">*</span>
                                </>
                              }
                              customClass="mt-2 hl-supplier-title"
                            />
                            <TooltipCustom
                              id="supplierOriginTooltip"
                              width="300px"
                              tooltipText={
                                <>
                                  <ul class="hl-tooltip-list">
                                    <li>Selected supplier is for {supplierOrigin === "1" ? "Indian" : "Overseas"}.</li>
                                    <li>Gray highlighted field can't be changed since it prefilled information during repository approval.</li>
                                  </ul>
                                </>
                              }
                            />
                          </div>
                          <Label
                            className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box"
                            check
                          >
                            <input
                              type="radio"
                              name="supplierOrigin"
                              className="zero-based"
                              id="1"
                              checked={supplierOrigin === "1"}
                              onChange={handleSupplierRadioChange}
                              disabled={true}
                            />
                            <span>Indian</span>
                          </Label>
                          <Label
                            className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                            check
                          >
                            <input
                              type="radio"
                              name="supplierOrigin"
                              className="vendor-based"
                              id="2"
                              checked={supplierOrigin === "2"}
                              onChange={handleSupplierRadioChange}
                              disabled={true}
                            />
                            <span>Overseas</span>
                          </Label>
                        </div>
                      </Col>
                      <Col md="12">
                        <hr className="hr-seprator" />
                        <HeaderTitle
                          title={"Supplier Repository"}
                          customClass="mt-4"
                        />
                      </Col>

                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("CompanyName")}
                          label="Supplier Repository"
                          rules={{ required: true }}
                          name="CompanyName"
                          placeholder="Select"
                          Controller={Controller}
                          control={control}
                          register={register}
                          options={renderListing("CompanyName")}
                          mandatory={true}
                          handleChange={(value) => {
                            // Construct payload
                            setSendToApiPotentialData(value);
                            // Send payload to API or perform further actions

                            setValue("Country", "");
                            setValue("ContactPersonDesignation", "");
                            setValue("ContactPersonName", "");
                            setValue("VendorName", "");
                            setValue("SupplierOriginSources", "");
                            setValue("YearOfBusinessIncorporation", "");
                            setValue("MobileNo", "");
                            setValue("Email", "");
                            setValue("SupplierSpecialization", "");
                            setValue("State", "");
                            setValue("District", "");
                            setValue("City", "");
                            setValue("Category", " ")
                          }}
                          errors={errors?.CompanyName}
                          disabled={
                            supplierId || modeEdit === "edit" ? true : false
                          }
                        />
                      </Col>
                      <Col md="12">
                        <hr className="hr-seprator" />
                        <HeaderTitle
                          title={"Application Details:"}
                          customClass="mt-4"
                        />
                      </Col>
                      <Col
                        md="3"
                        className="d-flex justify-content-start align-items-center"
                      >
                        <div className="hl-title-tooltip">
                          <Label className="d-inline-block pl-1 mr-5 pt-0 mb-3">
                            Supplier Relation
                            <span className="asterisk-required">*</span>
                          </Label>
                        </div>
                        <div className="mb-2">
                          <Label
                            className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box"
                            check
                          >
                            <input
                              type="radio"
                              name="VendorRelation"
                              className="zero-based"
                              {...register("VendorRelation", {
                                required: true,
                              })}
                              id="VendorRelationNew"
                              value="1"
                              checked={vendorRelation === "1"}
                              onChange={(e) => setVendorRelation(e.target.value)}
                            />
                            <span>New</span>
                          </Label>
                          <Label
                            className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                            check
                          >
                            <input
                              type="radio"
                              name="VendorRelation"
                              className="zero-based"
                              {...register("VendorRelation", {
                                required: true,
                              })}
                              id="VendorRelationExisting"
                              value="0"
                              checked={vendorRelation === "0"}
                              onChange={(e) => setVendorRelation(e.target.value)}
                            />
                            <span>Existing</span>
                          </Label>
                        </div>
                      </Col>

                      <Col md="3">
                        <TextFieldHookForm
                          {...register("VendorName")}
                          label={`Company Name`}
                          // rules={{ required: true, }}
                          name={"VendorName"}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces },
                            maxLength: 200,
                          }}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          register={register}
                          handleChange={() => { }}
                          // className=""
                          customClassName={"withBorder"}
                          errors={errors.VendorName}
                          disabled={false}
                          mandatory={true}
                        />
                      </Col>
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("Plant")}
                          label="Plant"
                          rules={{ required: true }}
                          name="Plant"
                          placeholder="Select"
                          Controller={Controller}
                          control={control}
                          register={register}
                          options={renderListing("PlantData")}
                          mandatory={true}
                          handleChange={(value) => {
                            handleSelectChange(value);
                          }}
                          errors={errors?.Plant}
                          disabled={false}
                        />
                      </Col>
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("Category")}
                          label="Category"
                          rules={{ required: true }}
                          name="Category"
                          placeholder="Select"
                          Controller={Controller}
                          control={control}
                          register={register}
                          options={renderListing("CategoryData")}
                          mandatory={true}
                          handleChange={(value) => {
                            handleCategoryDivisionMaster(value);
                          }}
                          errors={errors?.Category}
                          disabled={VendorRegID ? true : false}
                        />
                      </Col>

                      {(idDataFromSupplier?.SpecializationName || dataVendorRegistrationIdData?.SupplierSpecializationName || downloadButtonForSupplier?.SpecializationName) && (
                        <Col md="3">
                          <div className="form-group inputbox withBorder">
                            <label>
                              Supplier Specialization
                              <span className="asterisk-required">*</span>
                            </label>
                            <Controller
                              name="SpecializationName"
                              control={control}
                              defaultValue={idDataFromSupplier?.SpecializationName || dataVendorRegistrationIdData?.SupplierSpecializationName || downloadButtonForSupplier?.SpecializationName}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  className="form-control"
                                  type="text"
                                  disabled
                                />
                              )}
                            />
                          </div>
                        </Col>
                      )}
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("OtherSupplierSpecialization")}
                          label="Other Specialization"
                          rules={{ required: false }}
                          name="OtherSupplierSpecialization"
                          placeholder="Select"
                          Controller={Controller}
                          isMulti={true}
                          control={control}
                          register={register}
                          options={renderListing("SupplierSpecializationData")}
                          mandatory={false}
                          handleChange={(value) => {
                            handleSelectChange(value);
                          }}
                          errors={errors?.OtherSupplierSpecialization}
                          disabled={false}
                        />
                      </Col>
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("Division")}
                          label="Division"
                          rules={{ required: checkDivison }}
                          name="Division"
                          placeholder="Select"
                          Controller={Controller}
                          control={control}
                          register={register}
                          options={renderListing("DivisionData")}
                          mandatory={checkDivison}
                          handleChange={(value) => {
                            //   handleSelectChange(value);
                          }}
                          errors={errors?.Division}
                          disabled={!checkDivison}
                        />
                      </Col>
                      <Col md="3">
                        <div className="d-flex align-items-center">
                          <div className="fullinput-icon">
                            <TooltipCustom
                              id="businessYearTooltip"
                              width="350px"
                              tooltipText={
                                <>
                                  Please enter the value in numbers excluding
                                  the unit.
                                  <br />
                                  Ex- If your value is 200,000 you can simply
                                  write 2 in the text box as lakh is the default
                                  unit.
                                </>
                              }
                            />
                            <TextFieldHookForm
                              {...register("ExpectedBusiness")}
                              label={`Expected Business/Year (INR)`}
                              name={"ExpectedBusiness"}
                              Controller={Controller}
                              handleChange={() => { }}
                              rules={{
                                required: true,
                                validate: { checkWhiteSpaces, numberHavells },
                                maxLength: 10,
                              }}
                              control={control}
                              placeholder={"Enter"}
                              customClassName={"withBorder"}
                              errors={errors.ExpectedBusiness}
                              disabled={false}
                              mandatory={true}
                              inputWrapClass="hl-append-wrap"
                              appendClass="d-block-input"
                              appendText="Lakh"
                            />
                          </div>
                        </div>
                      </Col>
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("PaymentTerms")}
                          label="Payment Terms"
                          rules={{ required: true }}
                          name="PaymentTerms"
                          placeholder="Select"
                          Controller={Controller}
                          control={control}
                          register={register}
                          options={renderListing("PaymentTermsData")}
                          mandatory={true}
                          handleChange={(value) => {
                            handleSelectChange(value);
                          }}
                          errors={errors?.PaymentTerms}
                          disabled={false}
                        />
                      </Col>
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("PaymenttermsRemarks")}
                          label={`Payment Term Remark`}
                          name={"PaymenttermsRemarks"}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          handleChange={() => { }}
                          rules={{
                            required: false,
                            validate: {
                              checkWhiteSpaces,
                              alphaNumericHavells,
                            },
                            maxLength: 100,
                          }}
                          // register={register}
                          // className=""
                          customClassName={"withBorder"}
                          errors={errors.PaymenttermsRemarks}
                          disabled={false}
                        />
                      </Col>
                      <Col md="6">
                        <label>
                          Company Profile
                          <TooltipCustom
                            id="companyProfileTooltip"
                            customClass="hl-com-profile"
                            tooltipText="Allowed file formats: .jpeg, .jpg, .pdf, .xls, .ppt, and others."
                          />
                        </label>
                        <div className="d-flex w-100 pt-2">
                          {downloadButtonForSupplier?.CompanyProfileAttachment && !companyProfile.isRemove && (
                            <span className="text-uppercase pr-0 mr-5">
                              <Button
                                className="hl-upload-btn hl-mb-0 ml-0"
                                title="Download"
                                onClick={() => {
                                  handleDownload(downloadButtonForSupplier?.CompanyProfileAttachment);
                                }}
                                disabled={false}
                              >
                                <div className="download mr-0"></div>
                              </Button>
                            </span>
                          )}
                          {!downloadButtonForSupplier?.CompanyProfileAttachment &&
                            <FileUpload
                              uploaMainWrap="hl-ml-0 hl-upload-main w-50"
                              uploadClass="hl-mb-0"
                              control={control}
                              name="VendorCompanyProfileDocument"
                              // label="Upload GST Attachment"
                              onFileChange={(file) =>
                                handleComapnayProfileUpload(file)
                              }
                              onDelete={handleCompanyProfileDelete}
                              download={downloadButtonForSupplier}
                              setFile={() => setCompanyProfile}
                              uploadedFile={companyProfile}
                              setUplaodedFile={setCompanyProfile}
                              allowedFileTypes={[
                                "application/pdf",
                                "application/msword", // .doc (Word)
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx (Word)
                                "image/jpeg",
                                "image/jpg",
                                "image/png",
                                "application/vnd.ms-excel", // .xls (Excel)
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel)
                                "application/vnd.ms-powerpoint", // .ppt (PowerPoint)
                                "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx (PowerPoint)
                              ]}
                            />}
                        </div>
                      </Col>


                    </Row>
                    <hr className="hr-seprator mt-4 mb-1" />
                    <Row className="part-detail-wrapper">
                      <Col md="12">
                        <HeaderTitle
                          title={"Supplier Information:"}
                          customClass="mt-4"
                        />
                      </Col>
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("SupplierOriginSources")}
                          label="Origin of Sources/Reference"
                          rules={{ required: true }}
                          name="SupplierOriginSources"
                          placeholder="Select"
                          Controller={Controller}
                          control={control}
                          register={register}
                          options={renderListing("SupplierOriginResources")}
                          mandatory={true}
                          handleChange={(value) => {
                            //   handleSelectChange(value);
                          }}
                          errors={errors?.SupplierOriginSources}
                          disabled={!!watch("SupplierOriginSources")}
                        />
                      </Col>
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("ContactPersonName")}
                          label={`Contact Person Name`}
                          name={"ContactPersonName"}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces, alphaNumeric },
                            maxLength: 50,
                          }}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          handleChange={() => { }}
                          // register={register}
                          // className=""
                          customClassName={"withBorder"}
                          errors={errors.ContactPersonName}
                          disabled={false}
                          mandatory={true}
                        />
                      </Col>
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("ContactPersonDesignation")}
                          label={`Contact Person Designation`}
                          name={"ContactPersonDesignation"}
                          Controller={Controller}
                          control={control}
                          handleChange={() => { }}
                          placeholder={"Enter"}
                          // register={register}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces, alphaNumeric },
                            maxLength: 50,
                          }}
                          // className=""
                          customClassName={"withBorder"}
                          errors={errors.ContactPersonDesignation}
                          disabled={false}
                          mandatory={true}
                        />
                      </Col>
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("YearOfBusinessIncorporation")}
                          label={"Year of Business Incorporation"}
                          name={"YearOfBusinessIncorporation"}
                          placeholder={"Select"}
                          Controller={Controller}
                          control={control}
                          rules={{ required: true }}
                          // register={register}
                          options={renderListing("yearOfBuisness")}
                          mandatory={true}
                          handleChange={(value) => {
                            handleYearChange(value);
                          }}
                          errors={errors.YearOfBusinessIncorporation}
                          disabled={false}
                        />
                      </Col>
                      {yearsDifference && (
                        <Col md="3">
                          <TextFieldHookForm
                            // {...register("EstablishmentRemarks")}
                            label={`Year of Incorporation Remarks`}
                            name={"EstablishmentRemarks"}
                            Controller={Controller}
                            control={control}
                            handleChange={() => { }}
                            placeholder={"Enter"}
                            register={register}
                            rules={{
                              required: yearsDifference,
                              validate: { checkWhiteSpaces, alphaNumeric },
                              maxLength: 50,
                            }}
                            // className=""
                            customClassName={"withBorder"}
                            errors={errors.EstablishmentRemarks}
                            disabled={false}
                            mandatory={true}
                          />
                        </Col>
                      )}
                      <Col md="3">
                        <TooltipCustom
                          id="mobileNoTooltip"
                          tooltipText={
                            <>Supplier Primary contact no. for all communication.</>
                          }
                        />

                        <TextFieldHookForm
                          {...register("MobileNo")}
                          label={`Contact Number`}
                          name={"MobileNo"}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces, numberHavells },
                            maxLength: supplierOrigin === "1" ? 10 : 15,
                          }}
                          // register={register}
                          // className=""
                          customClassName={"withBorder"}
                          errors={errors.MobileNo}
                          handleChange={() => { }}
                          mandatory={true}
                          disabled={
                            idDataFromSupplier || modeEdit === "edit"
                              ? true
                              : false
                          }
                        />
                      </Col>
                      <Col md="3">
                        <TooltipCustom
                          id="emailTooltip"
                          tooltipText={
                            <>Supplier Primary email id for all communication.</>
                          }
                        />
                        <TextFieldHookForm
                          {...register("Email")}
                          label={`Primary Email Address`}
                          name={"Email"}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces, email },
                            maxLength: 100,
                          }}
                          handleChange={() => { }}
                          customClassName={"withBorder"}
                          errors={errors.Email}
                          mandatory={true}
                          disabled={
                            idDataFromSupplier || modeEdit === "edit"
                              ? true
                              : false
                          }
                        />
                      </Col>
                    </Row>
                    <hr className="hr-seprator" />
                    <Row className="part-detail-wrapper">
                      <Col md="12">
                        <HeaderTitle
                          title={"Supplier Work Location:"}
                          customClass="mt-4"
                        />
                      </Col>
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("Country")}
                          label={"Country"}
                          name={"Country"}
                          placeholder={"Select"}
                          Controller={Controller}
                          control={control}
                          rules={{ required: true }}
                          register={register}
                          options={renderListing("Country")}
                          mandatory={true}
                          handleChange={(value) => {
                            handleCountryChange(value);
                          }}
                          errors={errors.Country}
                          disabled={
                            idDataFromSupplier ? true : false || isDateValid
                          }
                        />
                      </Col>
                      <Col md="3">
                        <SearchableSelectHookForm
                          {...register("State")}
                          label={"State/Region"}
                          name={"State"}
                          placeholder={"Select"}
                          Controller={Controller}
                          control={control}
                          rules={{ required: true }}
                          register={register}
                          handleChange={(value) => {
                            handleStateChange(value);
                          }}
                          options={renderListing("State")}
                          mandatory={true}
                          // handleChange={() => {}}
                          errors={errors.State}
                          disabled={false}
                        />
                      </Col>
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("District")}
                          label={`District`}
                          name={"District"}
                          Controller={Controller}
                          control={control}
                          rules={{
                            required: supplierOrigin === "1",
                            validate: { checkWhiteSpaces, alphaNumeric },
                            maxLength: 50,
                          }}
                          placeholder={"Enter"}
                          register={register}
                          className=""
                          customClassName={"withBorder"}
                          errors={errors.District}
                          handleChange={() => { }}
                          disabled={false}
                          mandatory={supplierOrigin === "1"}
                        />
                      </Col>
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("City")}
                          label={`City`}
                          name={"City"}
                          Controller={Controller}
                          control={control}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces, alphaNumeric },
                            maxLength: 50,
                          }}
                          placeholder={"Enter"}
                          register={register}
                          options={renderListing("City")}
                          mandatory={true}
                          handleChange={() => { }}
                          errors={errors.City}
                          customClassName={"withBorder"}
                          disabled={false}
                        />
                      </Col>
                    </Row>
                    <hr className="hr-seprator" />
                    <Row className="part-detail-wrapper">
                      <Col md="12">
                        <HeaderTitle
                          title={"Why This New Supplier Required:"}
                          customClass="mt-4"
                        />
                      </Col>
                    </Row>
                    <Row className="part-detail-wrapper mt-3 mb-3">
                      <Col md="3">
                        <Label>
                          New Business Vertical/Products
                          <span className="asterisk-required">*</span>
                        </Label>
                        <Label
                          className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box"
                          check
                        >
                          <input
                            type="radio"
                            {...register("NewBusinessVertical")}
                            value="true"
                            defaultChecked // Ensure "Yes" option is checked by default
                          />
                          <span>Yes</span>
                        </Label>
                        <Label
                          className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                          check
                        >
                          <input
                            type="radio"
                            {...register("NewBusinessVertical")}
                            value="false"
                          />
                          <span>No</span>
                        </Label>
                      </Col>
                      <Col md="3" className="mb-3">
                        <Label>
                          Import Localization
                          <span className="asterisk-required">*</span>
                        </Label>
                        <Label
                          className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box"
                          check
                        >
                          <input
                            type="radio"
                            {...register("Importlocalization")}
                            value="true"
                            defaultChecked // Ensure "Yes" option is checked by default
                          />
                          <span>Yes</span>
                        </Label>
                        <Label
                          className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                          check
                        >
                          <input
                            type="radio"
                            {...register("Importlocalization")}
                            value="false"
                          />
                          <span>No</span>
                        </Label>
                      </Col>
                      <Col md="3" className="mb-3">
                        <Label>
                          Due to Single Source
                          <span className="asterisk-required">*</span>
                        </Label>
                        <Label
                          className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0 radio-box"
                          check
                        >
                          <input
                            type="radio"
                            {...register("DuetoSingleSource")}
                            value="true"
                            defaultChecked // Ensure "Yes" option is checked by default
                          />
                          <span>Yes</span>
                        </Label>
                        <Label
                          className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                          check
                        >
                          <input
                            type="radio"
                            {...register("DuetoSingleSource")}
                            value="false"
                          />
                          <span>No</span>
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <Row className="part-detail-wrapper mt-3">
                          <Col md="12">
                            <Label>
                              Commercial Reason{" "}
                              <span className="asterisk-required">*</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pr-5 mr-5 mb-3 pt-0 radio-box pl-2"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="Commercial"
                                className="zero-based"
                                id="IsExistingSupplierTrue"
                                {...register("Commercial", {
                                  required: true,
                                })}
                                // value={true}
                                value="true"
                              // checked={watch("IsExistingSupplier")?true:false}
                              />
                              <span>Yes</span>
                            </Label>
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="Commercial"
                                className="vendor-based"
                                id="IsExistingSupplierFalse"
                                {...register("Commercial", {
                                  required: true,
                                })}
                                // value={false}
                                value="false"
                              // checked={watch("IsExistingSupplier")?false:true}
                              />
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            {watch("Commercial") === "true" && (
                              <SearchableSelectHookForm
                                {...register("CommercialReason")}
                                label={"Reason"}
                                name={"CommercialReason"}
                                placeholder={"Select"}
                                Controller={Controller}
                                control={control}
                                rules={{ required: true }}
                                // register={register}
                                options={renderListing(
                                  "commercialReasonMasterData"
                                )}
                                mandatory={true}
                                handleChange={() => { }}
                                errors={errors.CommercialReason}
                                disabled={false}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>
                      <Col md="4">
                        <Row className="part-detail-wrapper mt-3">
                          <Col md="12">
                            <Label>
                              Other Reason (Capex, Jobs, Worker, Service, etc.)
                              <span className="asterisk-required">*</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="Other"
                                {...register("Other", {
                                  required: true,
                                })}
                                className="zero-based"
                                id="OtherTrue"
                                value="true"
                              />{" "}
                              <span>Yes</span>
                            </Label>
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="Other"
                                className="vendor-based"
                                {...register("Other", {
                                  required: true,
                                })}
                                id="OtherFalse"
                                value="false"
                              />{" "}
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            {watch("Other") === "true" && (
                              <TextFieldHookForm
                                {...register("OtherReason")}
                                label={`Other Reason`}
                                name={"OtherReason"}
                                Controller={Controller}
                                control={control}
                                placeholder={"Enter"}
                                rules={{
                                  required: true,
                                  validate: {
                                    checkWhiteSpaces,
                                    checkPaymentTermsRemarks,
                                  },
                                  maxLength: 50,
                                }}
                                handleChange={() => { }}
                                // register={register}
                                // className=""
                                customClassName={"withBorder mb-0"}
                                errors={errors.OtherReason}
                                disabled={false}
                                mandatory={true}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>
                      <Col md="4">
                        <Row className="part-detail-wrapper mt-3">
                          <Col md="12">
                            <Label>
                              If existing Supplier Available, Discussions Done?
                              <span className="asterisk-required">*</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="ExistingSupplierAvialableAndDiscussion"
                                className="zero-based"
                                {...register(
                                  "ExistingSupplierAvialableAndDiscussion",
                                  {
                                    required: true,
                                  }
                                )}
                                id="ExistingSupplierAvialableAndDiscussiontrue"
                                value="true"
                              />{" "}
                              <span>Yes</span>
                            </Label>
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                {...register(
                                  "ExistingSupplierAvialableAndDiscussion",
                                  {
                                    required: true,
                                  }
                                )}
                                name="ExistingSupplierAvialableAndDiscussion"
                                className="vendor-based2"
                                id="ExistingSupplierAvialableAndDiscussionFalse"
                                value="false"
                              />{" "}
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            {watch("ExistingSupplierAvialableAndDiscussion") ===
                              "true" && (
                                <TextFieldHookForm
                                  {...register(
                                    "ExistingSupplierAvialableAndDiscusionComment"
                                  )}
                                  label={`Comment`}
                                  name={
                                    "ExistingSupplierAvialableAndDiscusionComment"
                                  }
                                  Controller={Controller}
                                  rules={{
                                    required: true,
                                    validate: {
                                      checkWhiteSpaces,
                                      checkPaymentTermsRemarks,
                                    },
                                    maxLength: 100,
                                  }}
                                  control={control}
                                  placeholder={"Enter"}
                                  // register={register}
                                  // className=""
                                  customClassName={"withBorder mb-0"}
                                  handleChange={() => { }}
                                  errors={
                                    errors.ExistingSupplierAvialableAndDiscusionComment
                                  }
                                  disabled={false}
                                  mandatory={true}
                                />
                              )}
                          </Col>
                        </Row>
                      </Col>
                      <Col md="4">
                        <Row className="part-detail-wrapper mt-3">
                          <Col md="12">
                            <Label>
                              Discussions with Central Category / NPD Team
                              <span className="asterisk-required">*</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="DiscussionWithNDTTeam"
                                className="zero-based"
                                {...register("DiscussionWithNDTTeam", {
                                  required: true,
                                })}
                                id="DiscussionWithNDTTeamTrue"
                                value="true"
                              />{" "}
                              <span>Yes</span>
                            </Label>
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                {...register("DiscussionWithNDTTeam", {
                                  required: true,
                                })}
                                name="DiscussionWithNDTTeam"
                                className="vendor-based2"
                                id="DiscussionWithNDTTeamFalse"
                                value="false"
                              />{" "}
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            {watch("DiscussionWithNDTTeam") === "true" && (
                              <TextFieldHookForm
                                {...register("DiscussionWithNDTTeamComment")}
                                label={`Comment`}
                                name={"DiscussionWithNDTTeamComment"}
                                Controller={Controller}
                                rules={{
                                  required: true,
                                  validate: {
                                    checkWhiteSpaces,
                                    alphaNumericHavells,
                                  },
                                  maxLength: 100,
                                }}
                                control={control}
                                placeholder={"Enter"}
                                // register={register}
                                // className=""
                                customClassName={"withBorder mb-0"}
                                handleChange={() => { }}
                                errors={errors.DiscussionWithNDTTeamComment}
                                disabled={false}
                                mandatory={true}
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>
                      <Col md="4">
                        <Row className="part-detail-wrapper mt-3">
                          <Col md="12">
                            <Label>
                              New Location Added by Existing Supplier
                              <span className="asterisk-required">*</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                              check
                            >
                              <input
                                type="radio"
                                name="NewLocationAddedByExistingSupplier"
                                className="zero-based"
                                {...register(
                                  "NewLocationAddedByExistingSupplier",
                                  {
                                    required: true,
                                  }
                                )}
                                id="NewLocationAddedByExistingSupplierTrue"
                                value="true"
                              />
                              <span>Yes</span>
                            </Label>
                            <Label
                              className="d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              check
                            >
                              <input
                                type="radio"
                                name="NewLocationAddedByExistingSupplier"
                                {...register(
                                  "NewLocationAddedByExistingSupplier",
                                  {
                                    required: true,
                                  }
                                )}
                                className="vendor-based"
                                id="NewLocationAddedByExistingSupplierFalse"
                                value="false"
                              />{" "}
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            {watch("NewLocationAddedByExistingSupplier") ===
                              "true" && (
                                <TextFieldHookForm
                                  rules={{
                                    required: true,
                                    validate: {
                                      checkWhiteSpaces,
                                      alphaNumericHavells
                                    },
                                    maxLength: 100
                                  }}
                                  label={`Comment`}
                                  name={
                                    "NewLocationAddedByExistingSupplierComment"
                                  }
                                  Controller={Controller}
                                  register={register}
                                  control={control}
                                  placeholder={"Enter"}
                                  customClassName={"withBorder mb-0"}
                                  handleChange={() => { }}
                                  errors={
                                    errors.NewLocationAddedByExistingSupplierComment
                                  }
                                  disabled={false}
                                  mandatory={true}
                                />
                              )}
                          </Col>
                        </Row>
                      </Col>
                      <Col md="4">
                        <Row className="part-detail-wrapper mt-3">
                          <Col md="12">
                            <Label>
                              Replacement of Existing Supplier (For Code
                              Closure)
                              <span className="asterisk-required">*</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="ReplacementExistingVendor"
                                className="zero-based"
                                {...register("ReplacementExistingVendor", {
                                  required: true,
                                })}
                                id="ReplacementExistingVendorTrue"
                                value="true"
                              />{" "}
                              <span>Yes</span>
                            </Label>
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="ReplacementExistingVendor"
                                {...register("ReplacementExistingVendor", {
                                  required: true,
                                })}
                                className="vendor-based"
                                id="ReplacementExistingVendorFalse"
                                value="false"
                              />{" "}
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Row>
                              <Col md="6">
                                {watch("ReplacementExistingVendor") ===
                                  "true" && (
                                    <TextFieldHookForm
                                      {...register(
                                        "ReplacementofExistingVendorCode"
                                      )}
                                      label={`Supplier Code`}
                                      name={"ReplacementofExistingVendorCode"}
                                      Controller={Controller}
                                      rules={{
                                        required: true,
                                        validate: {
                                          checkWhiteSpaces,
                                          alphaNumeric,
                                        },
                                        maxLength: 50,
                                      }}
                                      control={control}
                                      placeholder={"Enter"}
                                      // register={register}
                                      // className=""
                                      customClassName={"withBorder mb-0"}
                                      errors={
                                        errors.ReplacementofExistingVendorCode
                                      }
                                      disabled={false}
                                      mandatory={true}
                                      handleChange={(e) => {
                                        setIsSupplierCodeValid(false);
                                        setHasSupplierCodeChanged(true);
                                        const uppercaseValue = e.target.value.toUpperCase(); // Convert input value to uppercase
                                        e.target.value = uppercaseValue;
                                      }}
                                      onFieldBlur={(e) => {
                                        if (hasSupplierCodeChanged) {
                                          validateSupplierCode(e.target.value);
                                          setHasSupplierCodeChanged(false);
                                        }
                                      }}
                                    />
                                  )}
                              </Col>
                              <Col md="6">
                                {watch("ReplacementExistingVendor") ===
                                  "true" && (
                                    <TextFieldHookForm
                                      {...register("ExistingPaymentTerms")}
                                      label={`Payment Terms`}
                                      name={"ExistingPaymentTerms"}
                                      Controller={Controller}
                                      rules={{
                                        required: true,
                                        validate: {
                                          checkWhiteSpaces,
                                          alphaNumericHavells,
                                        },
                                        maxLength: 100,
                                      }}
                                      control={control}
                                      placeholder={"Enter"}
                                      // register={register}
                                      // className=""
                                      customClassName={"withBorder mb-0"}
                                      handleChange={() => { }}
                                      errors={errors.ExistingPaymentTerms}
                                      disabled={false}
                                      mandatory={true}
                                    />
                                  )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="6">
                        <Row className="part-detail-wrapper mt-3">
                          <Col md="12">
                            <Label>
                              Cost Saving
                              <span className="asterisk-required">*</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="CostSaving"
                                className="zero-based"
                                {...register("CostSaving", {
                                  required: true,

                                })}
                                onChange={(e) => setCostSaving(e.target.value)}
                                id="CostSavingTrue"
                                value="true"
                              />{" "}
                              <span>Yes</span>
                            </Label>
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="CostSaving"
                                {...register("CostSaving", {
                                  required: true,
                                  // onChange: (e) => setCostSaving(e.target.value),
                                })}
                                onChange={(e) => setCostSaving(e.target.value)}
                                className="vendor-based"
                                id="CostSavingFalse"
                                value="false"
                              />{" "}
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Row>
                              {costSaving == "true" && (
                                <Col md="4">
                                  <TooltipCustom
                                    id="howMuchAnnuallyTooltip"
                                    tooltipText={
                                      <>
                                        Please enter the value in numbers excluding the unit.
                                        <br />
                                        Ex- If your value is 200,000 you can simply write 2 in the text box as lakh is the default unit.
                                      </>
                                    }
                                  />
                                  <TextFieldHookForm
                                    {...register("HowMuchAnnuallyCostSaving")}
                                    label={`How Much Annually`}
                                    name={"HowMuchAnnuallyCostSaving"}
                                    Controller={Controller}
                                    handleChange={() => { }}
                                    rules={{
                                      required: true,
                                      validate: {
                                        checkWhiteSpaces,
                                        numberHavells,
                                      },
                                      maxLength: 10,
                                    }}
                                    control={control}
                                    placeholder={"Enter"}
                                    customClassName={"withBorder"}
                                    errors={errors.HowMuchAnnuallyCostSaving}
                                    disabled={false}
                                    mandatory={true}
                                    inputWrapClass="hl-append-wrap"
                                    appendClass="d-block-input"
                                    appendText="Lakh"
                                  />
                                </Col>
                              )}
                              <Col md="4">
                                {costSaving == "true" && (
                                  <TextFieldHookForm
                                    {...register("WhatPercentAnnuallyCostSaving")}
                                    label={`What Percent Annually`}
                                    name={"WhatPercentAnnuallyCostSaving"}
                                    Controller={Controller}
                                    handleChange={() => { }}
                                    rules={{
                                      required: true,
                                      validate: {
                                        checkWhiteSpaces,
                                        numberHavells,
                                      },
                                      maxLength: 10,
                                    }}
                                    control={control}
                                    placeholder={"Enter"}
                                    customClassName={"withBorder"}
                                    errors={errors.WhatPercentAnnuallyCostSaving}
                                    disabled={false}
                                    mandatory={true}
                                    inputWrapClass="hl-append-wrap"
                                    appendClass="d-block-input"
                                    appendText="%"
                                  />
                                )}
                              </Col>
                              {costSaving == "true" && (
                                <Col md="4">
                                  <label>
                                    Upload Evidence{" "}
                                    <TooltipCustom
                                      id="evidenceTooltip"
                                      customClass="hl-com-profile"
                                      tooltipText={
                                        <>
                                          Allowed file formats: .pdf, .xls, .doc.
                                        </>
                                      }
                                    />
                                  </label>
                                  <FileUpload
                                    uploaMainWrap="hl-ml-0 hl-upload-main"
                                    control={control}
                                    name="costSavingDocument"
                                    onFileChange={(file) => handleEvidenceUpload(file)}
                                    onDelete={handleUploadEvidenceDelete}
                                    setFile={() => setUploadEvidenceFile}
                                    uploadedFile={uploadEvidenceFile}
                                    setUplaodedFile={setUploadEvidenceFile}
                                    allowedFileTypes={[
                                      "application/pdf",
                                      "application/msword", // .doc files
                                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
                                      "application/vnd.ms-excel", // .xls files
                                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
                                    ]}
                                  />
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="7">
                        <Row className="part-detail-wrapper pb-4 mt-3">
                          <Col md="12">
                            <Label>
                              Cost Sheet
                              <span className="asterisk-required">*</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="CostSheet"
                                {...register("CostSheet", {
                                  required: true,
                                })}
                                className="zero-based"
                                id="CostSheetTrue"
                                value="true"
                              />{" "}
                              <span>Yes</span>
                            </Label>
                            <Label
                              className={
                                "d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box"
                              }
                              check
                            >
                              <input
                                type="radio"
                                name="CostSheet"
                                {...register("CostSheet", {
                                  required: true,
                                })}
                                className="vendor-based"
                                id="CostSheetFalse"
                                value="false"
                                disabled={costSaving == "true" || selectedCategoryCostSheet === "true"}
                              />{" "}
                              <span>No</span>
                            </Label>
                          </Col>
                          <Col md="12">
                            {watch("CostSheet") === "true" && (
                              <>
                                <label>
                                  Upload Cost Sheet Document
                                  <TooltipCustom
                                    id="costSheetTooltip"
                                    customClass="hl-com-profile"
                                    tooltipText={
                                      <>
                                        Allowed file formats: .pdf, .xls, .doc.
                                      </>
                                    }
                                  />
                                </label>
                                <FileUpload
                                  {...register("CostSheetDocument")}
                                  uploaMainWrap="hl-ml-0 hl-upload-main"
                                  control={control}
                                  name="CostSheetDocument"
                                  onFileChange={(file) => handleCostSheetDocument(file)}
                                  onDelete={() => {
                                    setValue("CostSheetDocument", null);
                                    setIsoFile((p) => ({
                                      ...p,
                                      isRemove: true,
                                    }));
                                  }}
                                  setFile={() => setIsoFile}
                                  uploadedFile={isoFile}
                                  setUplaodedFile={setIsoFile}
                                  allowedFileTypes={[
                                    "application/pdf",
                                    "application/msword", // .doc files
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx files
                                    "application/vnd.ms-excel", // .xls files
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx files
                                  ]}
                                  rules={{ required: "File required" }}
                                  errors={errors?.CostSheetDocument}
                                />
                              </>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="part-detail-wrapper pb-5 mt-3">
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("SupplierServiceDescription")}
                          label={
                            <>
                              Description: Part/FG/Service
                              <span className="asterisk-required">*</span>
                              <TooltipCustom
                                id="partFgTooltip"
                                tooltipText={
                                  <>For which Supplier has been Identified.</>
                                }
                              />
                            </>
                          }
                          name={"SupplierServiceDescription"}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces, alphaNumericHavells },
                            maxLength: 100,
                          }}
                          customClassName={"withBorder mb-0"}
                          handleChange={() => { }}
                          errors={errors.SupplierServiceDescription}
                          disabled={false}
                          mandatory={false}
                        />
                      </Col>
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("ExistingSupplierFeedback")}
                          label={`Feedback of Existing Supplier`}
                          name={"ExistingSupplierFeedback"}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces, alphaNumericHavells },
                            maxLength: 100,
                          }}
                          customClassName={"withBorder mb-0"}
                          handleChange={() => { }}
                          errors={errors.ExistingSupplierFeedback}
                          disabled={false}
                          mandatory={true}
                        />
                      </Col>
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("EstimatedStartOfSuppies")}
                          label={`Estimated Start of Supplies / Services (Month)`}
                          name={"EstimatedStartOfSuppies"}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          rules={{
                            required: true,
                            validate: { checkWhiteSpaces, alphaNumericHavells },
                            maxLength: 100,
                          }}
                          customClassName={"withBorder mb-0"}
                          handleChange={() => { }}
                          errors={errors.EstimatedStartOfSuppies}
                          disabled={false}
                          mandatory={true}
                        />
                      </Col>
                      {/* <Col md="3">
                        <SearchableSelectHookForm
                          {...register("LocationChangeOfExistingSupplier")}
                          label={"Location Change of Existing Supplier"}
                          name={"LocationChangeOfExistingSupplier"}
                          placeholder={"Select"}
                          Controller={Controller}
                          control={control}
                          rules={{
                            required: false,
                            validate: { checkWhiteSpaces },
                            maxLength: 50,
                          }}
                          // register={register}
                          options={renderListing("commercialReasonMasterData")}
                          mandatory={true}
                          handleChange={() => { }}
                          errors={errors.LocationChangeOfExistingSupplier}
                          disabled={false}
                        />
                      </Col> */}
                      <Col md="3">
                        <TextFieldHookForm
                          {...register("CompanyProfileWebsite")}
                          label={`Website`}
                          name={"CompanyProfileWebsite"}
                          Controller={Controller}
                          control={control}
                          placeholder={"Enter"}
                          rules={{
                            required: false,
                            validate: { checkWhiteSpaces, validateUrlHavells },
                            maxLength: 50,
                          }}
                          customClassName={"withBorder mb-0"}
                          handleChange={() => { }}
                          errors={errors.CompanyProfileWebsite}
                          disabled={false}
                          mandatory={false}
                        />
                      </Col>
                      <Col md="6">
                        <TextAreaHookForm
                          label={
                            "Why existing suppliers currently associated with group cannot fulfil the need? (Please give justification)"
                          }
                          name={"Remarks"}
                          rules={{
                            required: false,
                            validate: { checkWhiteSpaces, alphaNumericHavells },
                            maxLength: 1000,
                          }}
                          placeholder={true ? "Enter" : "Enter"}
                          Controller={Controller}
                          control={control}
                          register={register}
                          mandatory={false}
                          customClassName={"withBorder"}
                          handleChange={handleRemarksChange} // Pass the event handler
                          errors={errors.Remarks}
                          disabled={false}
                          rowHeight={2}
                        />
                      </Col>
                      <Col md="3">
                        <Row>
                          {supplierOrigin === "1" && (
                            <Col md="6">
                              <label>
                                Saverisk Document
                                <TooltipCustom
                                  id="saveriskDocumentTooltip"
                                  customClass="hl-com-profile"
                                  width="250"
                                  tooltipText={
                                    <>
                                      <ul className="hl-tooltip-list">
                                        <li>
                                          Upload the Risk Assessment Document -
                                          If found on Saverisk.
                                        </li>
                                        <li>
                                          Allowed file formats: .jpeg, .jpg,
                                          .pdf, .xls, .ppt, and others.
                                        </li>
                                      </ul>
                                    </>
                                  }
                                />
                              </label>

                              <div className="d-flex pt-2">
                                {downloadButtonForSupplier?.RiskAssessmentDocumentAttachment && !saveRiskFile.isRemove && (
                                  <span className="d-flex w-100 mr-5">
                                    <Button
                                      className="hl-upload-btn hl-mb-0"
                                      title="Download"
                                      onClick={() => {
                                        handleDownload(downloadButtonForSupplier?.RiskAssessmentDocumentAttachment);
                                      }}
                                      disabled={false}
                                    >
                                      <div className="download mr-0"></div>
                                    </Button>
                                  </span>
                                )}
                                {!downloadButtonForSupplier?.RiskAssessmentDocumentAttachment &&
                                  <FileUpload
                                    uploaMainWrap="hl-ml-0 hl-upload-main w-100"
                                    control={control}
                                    name="SaveriskDocument"
                                    // label="Upload GST Attach22ment"
                                    onFileChange={(file) =>
                                      handleSaveRiskUpload(file)
                                    }
                                    onDelete={handleSaveRiskDelete}
                                    setFile={() => setSaveRiskFile}
                                    uploadedFile={saveRiskFile}
                                    setUplaodedFile={setSaveRiskFile}
                                    allowedFileTypes={[
                                      "application/pdf",
                                      "application/msword", // .doc (Word)
                                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx (Word)
                                      "image/jpeg",
                                      "image/jpg",
                                      "image/png",
                                      "application/vnd.ms-excel", // .xls (Excel)
                                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (Excel)
                                      "application/vnd.ms-powerpoint", // .ppt (PowerPoint)
                                      "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx (PowerPoint)
                                    ]}
                                  />}
                              </div>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                    <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer hl-btm-footer">
                      <div className="col-sm-12 text-right bluefooter-butn">
                        <button
                          type={"button"}
                          className="reset mr-2 cancel-btn"
                          onClick={cancel}
                        >
                          <div className={"cancel-icon"}></div>
                          {"Cancel"}
                        </button>
                        <button
                          type="submit"
                          className="submit-button save-btn"
                        >
                          <div className="send-for-approval mr-1"></div>
                          {VendorRegID ? "Update" : "Submit"}
                        </button>
                      </div>
                    </Row>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </Drawer > */}
      </div>
    </>
  );
}
export default AddVendorNeed;
